import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const selectProgressState = createFeatureSelector<State>('progress');

export const getProgressKeys$ = createSelector(selectProgressState, (state: State): string[] => state.progressKeys);

export const isProcessing$ = createSelector(
    selectProgressState,
    (state: State): boolean => state.progressKeys.length !== 0
);
